module.exports = __webpack_public_path__ + "static/hero1-5508d3ff470e54caf444e1dff7e02a8e.png";